import { LocalStorageKeys } from "@is/constants";
import { LocalStorageService } from "@is/services";
import { EventTrackType } from "@is/services/EventTracking";

export const useStoreEvents = () => {
  const storeEvent = (event: EventTrackType) => {
    const storedTrackEvents = LocalStorageService.getItem(
      LocalStorageKeys.TrackEvents
    );

    if (storedTrackEvents) {
      const trackEventParsed = JSON.parse(storedTrackEvents);

      trackEventParsed.push(event);

      LocalStorageService.setItem(
        LocalStorageKeys.TrackEvents,
        trackEventParsed
      );
    } else {
      LocalStorageService.setItem(LocalStorageKeys.TrackEvents, [event]);
    }
  };

  return {
    storeEvent,
  };
};
